var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-video-list__wrap"},[_c('div',{ref:"list",staticClass:"dd-video-list"},_vm._l((_vm.data),function(item,i){return _c('VideoListItem',{key:i,attrs:{"data":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }